import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

import DialogModal from "../../common/DialogModal";
import NotificationBar from "../../Parts/NotificationBar.jsx";
import ResetPasswordComponent from "../../ResetPassword/ResetPasswordComponent.jsx";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
    minWidth: "600px",
    margin: 0,
  },
});

class ChangeSecurityQuestionDialog extends React.Component {
  state = {
    message: "",
  };

  componentWillReceiveProps(nextProps) {
    //close dialog when API succeeds
    if (
      this.props.isSaving &&
      !nextProps.isSaving &&
      nextProps.error === null
    ) {
      nextProps.toggleDialog();
    }

    if (!this.props.error && nextProps.error) {
      if (
        nextProps.error &&
        nextProps.error.data &&
        nextProps.error.data.message &&
        typeof nextProps.error.data.message === "string"
      ) {
        this.setState({
          message: nextProps.error.data.message,
        });
      }
    }
  }

  renderErrorMessage = (message) => {
    if (message) {
      return (
        <NotificationBar
          message={message}
          type="error"
          open={true}
          autoClose={false}
          disableOnclickListener={true}
          style={{
            transform: "none",
            boxShadow: "none",
            width: "100%",
            boxSizing: "border-box",
            marginBottom: "20px",
          }}
        ></NotificationBar>
      );
    }
  };

  render() {
    const { classes, toggleDialog, user } = this.props;

    return (
      <DialogModal
        open={this.props.isOpen}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        onClose={toggleDialog}
        title="セキュリティの質問を変更"
        classes={{
          paper: classes.paper,
        }}
      >
        {this.renderErrorMessage(this.state.message)}
        <ResetPasswordComponent
          user={user}
          showPassword={false}
          showSecurityQuestion={true}
          postUsersUpdatePassword={
            this.props.postUsersUpdatePassword
          }
          buttonText="保存"
          error={this.props.error}
        />
      </DialogModal>
    );
  }
}

ChangeSecurityQuestionDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  error: PropTypes.object,
  postUsersUpdatePassword: PropTypes.func.isRequired,
  user: PropTypes.object,
};

export default withStyles(styles)(ChangeSecurityQuestionDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Basic/ChangeSecurityQuestionDialog.jsx